import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import PersonaBadge from '../common/PersonaBadge';
import api from '../../services/api';

const typeEmoji: Record<string, string> = {
  milestone: '\u{1F3C6}',
  streak: '\u2705',
  remix: '\u{1F9EC}',
  completion: '\u{1F4AF}',
  improvement: '\u{1F3AF}',
  speed: '\u26A1',
  first: '\u{1F31F}',
};

const WIN_GLOW: Record<string, string> = {
  milestone: 'shadow-amber-500/10',
  streak: 'shadow-blue-500/10',
  first: 'shadow-purple-500/10',
};

function isRecent(item: any): boolean {
  if (!item.created_at) return false;
  return Date.now() - new Date(item.created_at).getTime() < 3600000;
}

const RecentWins: React.FC = () => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    api.get('/analytics/cross-system/recent-wins')
      .then(r => setItems(r.data.items || []))
      .catch(console.error);
  }, []);

  if (items.length === 0) {
    return (
      <div className={`p-4 text-center text-sm ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
        No recent wins yet — keep building!
      </div>
    );
  }

  return (
    <div className="space-y-2 max-h-[400px] overflow-y-auto">
      {items.map((item, i) => (
        <div
          key={i}
          onClick={() => item.action_url && navigate(item.action_url)}
          className={`p-3 rounded-lg border-l-[3px] border-amber-500/60 cursor-pointer transition-all duration-200 hover:translate-x-1 ${
            isRecent(item) ? 'animate-pulse' : ''
          } ${darkMode ? 'bg-gray-800/50 hover:bg-gray-800' : 'bg-white hover:bg-gray-50'} ${
            WIN_GLOW[item.type] ? `shadow-lg ${WIN_GLOW[item.type]}` : ''
          }`}
        >
          <div className="flex items-start gap-2">
            <span className="text-lg leading-none">{typeEmoji[item.type] || '\u2728'}</span>
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-medium ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>{item.title}</p>
              <p className={`text-xs mt-0.5 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>{item.context}</p>
            </div>
            {item.persona_name && (
              <PersonaBadge personaId={item.persona_id || ''} personaName={item.persona_name} size="xs" clickable={false} />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentWins;
